<template>
  <v-container class="mx-0" :fluid="fluid">
    <v-row :justify="justifyCenter ? 'center' : null">
      <v-col sm="12" :lg="!fluid ? 10 : null" :xl="!fluid ? 8 : null">
        <slot></slot>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'FhContainer',
  props: {
    justifyCenter: Boolean,
    fluid: Boolean,
  },
}
</script>

<style scoped>

</style>
